module.exports = __webpack_public_path__ + "img/herb-thyme-350x184.3c18b641.jpg";